<template>
    <div class="areas">
        <h2 class="subheading grey--text">{{$t('Areas')}}</h2>
        <v-container class="my-5">
            <v-dialog v-model="dialog_update_equipament" max-width="400px">
                <v-card>
                    <v-card-text>
                        <v-text-field
                                v-model="nameEquipment_update"
                                v-if="dialog_update_equipament" autofocus
                                prepend-icon="build"
                                name="nameEquipment_update"
                                :label="$t('nombre')"
                                :error-messages="errores.nameEquipment"
                        >
                        </v-text-field>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn color="primary" @click="dialog_update_equipament=false">{{$t('cerrar')}}</v-btn>
                        <v-spacer/>
                        <v-btn color="primary" @click="modificar_equipo_area()">{{$t('modificar')}}</v-btn>
                </v-card-actions>
                </v-card>
            </v-dialog>
            <v-layout align-center justify-center fill-height>
                <v-dialog v-model="dialog" persistent max-width="500px">
                    <template
                            v-slot:activator="{ on }">
                        <v-btn
                                color="primary"
                                dark v-on="on"
                                @click="update = false, clean_fields()">
                            + {{$t('anadir_area')}}
                        </v-btn>
                    </template>
                    <v-form
                            @submit.prevent="update
                                        ? updateArea(id_update)
                                        : altaArea()">
                        <v-card class="elevation-5">
                            <v-toolbar dark color="primary">
                                <v-toolbar-title>
                                    {{$t('Areas')}}
                                </v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-btn
                                        class="align-self-end"
                                        color="red"
                                        icon
                                        @click="dialog = false">
                                    <v-icon>close</v-icon>
                                </v-btn>
                            </v-toolbar>
                            <v-card-text>
                                <v-text-field
                                        v-model="nombre"
                                        v-if="dialog" autofocus
                                        prepend-icon="location_city"
                                        name="nombre"
                                        :label="$t('nombre') + '*'"
                                        :error-messages="errores.nombre"
                                >
                                </v-text-field>
                                <v-text-field
                                        v-model="color.hex"
                                        @change-color="onChange"
                                        prepend-icon="color_lens"
                                        name="color"
                                        label="Color *"
                                        :error-messages="errores.color"
                                >
                                </v-text-field>
                                <Slider
                                        v-model="color"
                                        @change-color="onChange"
                                >
                                </Slider>
                                <v-alert
                                        :value=alerta
                                        type="warning"
                                        outline
                                        transition="scale-transition"
                                >
                                    Fallo con el Servidor
                                </v-alert>
                            </v-card-text>
                            <v-card-actions>
                                <v-btn
                                        color="primary"
                                        @click="clear(),
                                            dialog = false"
                                >{{this.$t('cerrar')}}
                                </v-btn>
                                <v-spacer/>
                                <v-btn
                                        v-if="update"
                                        :loading="loading"
                                        color="primary"
                                        type="submit"
                                >{{this.$t('modificar')}}
                                </v-btn>
                                <v-btn
                                        v-else
                                        :loading="loading"
                                        color="primary"
                                        type="submit"
                                >{{this.$t('agregar')}}
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-form>
                </v-dialog>
                <!--////////////////////////          ALTA DOCUMENTACION X AREA      ///////////////////////////////////-->
                <v-dialog v-model="dialog_add_documentation" max-width="450px">
                    <v-flex>
                        <v-card class="elevation-5">
                            <v-toolbar dark color="primary">
                                <v-toolbar-title>
                                    {{$t('add_attachment')}}
                                </v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-btn color="red" icon dark @click="clear(), dialog_add_documentation = false">
                                    <v-icon>close</v-icon>
                                </v-btn>
                            </v-toolbar>
                            <v-card-text>
                                <v-form @submit.prevent="alta_documentacion_area()">
                                    <v-select
                                        :disabled="update"
                                        v-model="idDocumentation"
                                        :items="documentations"
                                        item-text="name"
                                        item-value="idDocumentation"
                                        label="Documento"
                                        placeholder="Seleccione un documento del catálogo"
                                        :error-messages="errores.idDocumentation"
                                    >
                                    </v-select>
                                    <v-alert
                                            :value=alerta
                                            type="warning"
                                            outline
                                            transition="scale-transition"
                                    >
                                        Fallo con el Servidor
                                    </v-alert>
                                    <v-card-actions>
                                        <v-spacer/>
                                        <v-btn
                                                :loading="loadingAddDocumentation"
                                                color="primary"
                                                type="submit"
                                        >{{this.$t('agregar')}}
                                        </v-btn>
                                    </v-card-actions>
                                </v-form>
                                <v-data-table
                                        :headers="headersDoc"
                                        :loading="loading_data_documentacion_area"
                                        :items="documentacion_area"
                                        :rows-per-page-text="$t('filas_por_pagina')"
                                        :rows-per-page-items="[
                                        {text: '5', value: 5},
                                        {text: '10', value: 10},
                                        {text: '25', value: 25},
                                        {text: this.$t('todos'),
                                        value: -1}]"
                                >
                                    <template v-slot:items="props">
                                        <td align="center">
                                            <v-icon
                                                    medium
                                                    color="red"
                                                    @click="eliminar_documentacion_area(props.item.id)"
                                            >
                                                delete
                                            </v-icon>
                                        </td>
                                        <td>{{ props.item.name }}</td>
                                    </template>
                                    <!--<template v-slot:no-results>-->
                                    <!--<v-alert :value="true" color="error" icon="warning">-->
                                    <!--{{$t('ningun_resultado_1')}} "{{ search }}" {{$t('ningun_resultado_2')}}-->
                                    <!--</v-alert>-->
                                    <!--</template>-->
                                    <template v-slot:pageText="props">
                                        {{props.rowsPerPage}}
                                        {{$t('attachment')}} {{ props.pageStart }} - {{ props.pageStop }} {{$t('prep_de')}} {{ props.itemsLength }}
                                    </template>
                                </v-data-table>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                </v-dialog>
                <!--////////////////////////          ALTA EQUIPO X AREA      ///////////////////////////////////-->
                <v-dialog v-model="dialog_add_equipament" max-width="450px">
                    <v-flex>
                        <v-card class="elevation-5">
                            <v-toolbar dark color="primary">
                                <v-toolbar-title>
                                    {{$t('add_equipo_seguridad')}}
                                </v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-btn color="red" icon dark @click="clear(), dialog_add_equipament = false">
                                    <v-icon>close</v-icon>
                                </v-btn>
                            </v-toolbar>
                            <v-card-text>
                                <v-form
                                        @submit.prevent="alta_equipo_area()">
                                    <v-text-field
                                            v-model="nameEquipment"
                                            v-if="dialog_add_equipament" autofocus
                                            prepend-icon="build"
                                            name="nameEquipment"
                                            :label="$t('nombre')"
                                            :error-messages="errores.nameEquipment"
                                    >
                                    </v-text-field>
                                    <v-alert
                                            :value=alerta
                                            type="warning"
                                            outline
                                            transition="scale-transition"
                                    >
                                        Fallo con el Servidor
                                    </v-alert>
                                    <v-card-actions>
                                        <v-spacer/>
                                        <v-btn
                                                color="primary"
                                                type="submit"
                                        >{{this.$t('agregar')}}
                                        </v-btn>
                                    </v-card-actions>
                                </v-form>
                                <v-data-table
                                        :headers="headers2"
                                        :loading="loading_data_equipo_area"
                                        :items="equipos_area"
                                        :rows-per-page-text="$t('filas_por_pagina')"
                                        :rows-per-page-items="[
                            {text: '5', value: 5},
                            {text: '10', value: 10},
                            {text: '25', value: 25},
                            {text: this.$t('todos'),
                            value: -1}]"

                                >
                                    <template v-slot:items="props">
                                        <td align="center">
                                            <v-icon
                                                    medium
                                                    @click="dialog_update_equipament = true, id_equipament = props.item.id, nameEquipment_update = props.item.nameEquipment"
                                            >
                                                edit
                                            </v-icon>
                                        </td>
                                        <td align="center">
                                            <v-icon
                                                    medium
                                                    color="red"
                                                    @click="eliminar_equipo_area(props.item.id)"
                                            >
                                                delete
                                            </v-icon>
                                        </td>
                                        <td>{{ props.item.nameEquipment }}</td>
                                    </template>
                                    <!--<template v-slot:no-results>-->
                                    <!--<v-alert :value="true" color="error" icon="warning">-->
                                    <!--{{$t('ningun_resultado_1')}} "{{ search }}" {{$t('ningun_resultado_2')}}-->
                                    <!--</v-alert>-->
                                    <!--</template>-->
                                    <template v-slot:pageText="props">
                                        {{props.rowsPerPage}}
                                        {{$t('equipo_seguridad')}} {{ props.pageStart }} - {{ props.pageStop }} {{$t('prep_de')}} {{ props.itemsLength }}
                                    </template>
                                </v-data-table>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                </v-dialog>
            </v-layout>
            <v-layout class="my-4" align-center justify-center fill-height>
                <v-flex >
                    <v-card-title>
                        {{$t('Areas')}}
                        <v-spacer></v-spacer>
                        <v-text-field
                                v-model="search"
                                append-icon="search"
                                :label="$t('Buscar')"
                                single-line
                                hide-details
                        ></v-text-field>
                    </v-card-title>
                    <v-data-table
                            :headers="getProfile.roll === 5 ? headers : headers3"
                            :loading="loading_data_areas"
                            :items="areas"
                            :search="search"
                            :rows-per-page-text="$t('filas_por_pagina')"
                            :rows-per-page-items="[
                            {text: '5', value: 5},
                            {text: '10', value: 10},
                            {text: '25', value: 25},
                            {text: this.$t('todos'),
                            value: -1}]"

                    >
                        <template v-slot:items="props">
                            <td align="center">
                                <v-icon
                                        medium
                                        @click="fill_fields(props.item),
                                        update = true,
                                        dialog = true,
                                        id_update = props.item.id"
                                >
                                    edit
                                </v-icon>
                            </td>
                            <td v-if="getProfile.roll === 5" align="center">
                                <v-btn
                                        color="primary"
                                        @click="id_area = props.item.id, get_equipo_area(), dialog_add_equipament = true">
                                    + {{$t('agregar')}}
                                </v-btn>
                            </td>
                            <td v-if="getProfile.roll === 5" align="center">
                                <v-btn
                                        color="primary"
                                        @click="id_area = props.item.id, get_documentacion_area(), dialog_add_documentation = true">
                                    + {{$t('agregar')}}
                                </v-btn>
                            </td>
                            <!--                            <td>{{ props.item.id }}</td>-->
                            <td>{{ props.item.nombre }}</td>
                            <td>
                                <v-icon
                                        x-large
                                        :color="props.item.color"
                                >
                                    label
                                </v-icon>
                            </td>
                        </template>
                        <template v-slot:no-results>
                            <v-alert :value="true" color="error" icon="warning">
                                {{$t('ningun_resultado_1')}} "{{ search }}" {{$t('ningun_resultado_2')}}
                            </v-alert>
                        </template>
                        <template v-slot:pageText="props">
                            {{props.rowsPerPage}}
                            {{$t('equipo_seguridad')}} {{ props.pageStart }} - {{ props.pageStop }} {{$t('prep_de')}} {{ props.itemsLength }}
                        </template>
                    </v-data-table>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    import '@/plugins/axios'
    import store from '@/store'
    import Vue from 'vue'
    import VeeValidate from 'vee-validate'
    Vue.use(VeeValidate)
    import { mapState } from 'vuex'
    import { mapGetters } from 'vuex'
    import { Slider } from 'vue-color'

    export default {
        name: "areas",
        components: {
            Slider
        },
        data: () => ({
            color: {
                hex: '#FFFFFF'
            },
            alerta: false,
            dialog: false,
            update: false,
            id_update: 0,
            nombre: '',
            id_empresa: '',
            errores: [],
            search: '',
            headers: [],
            headers2: [],
            headers3: [],
            headersDoc: [],
            areas: [],
            equipos_area: [],
            documentacion_area: [],
            modal2: false,
            loading_data_areas: false,
            dialog_add_equipament: false,
            nameEquipment: '',
            id_area: '',
            loading_data_equipo_area: '',
            loading_data_documentacion_area: '',
            dialog_update_equipament: false,
            id_equipament: '',
            nameEquipment_update: '',
            loading: false,
            dialog_add_documentation: false,
            loadingAddDocumentation: false,
            documentations: [],
            idDocumentation: '',
        }),
        beforeUpdate(){
            this.headers = [
                {
                    text: this.$t('modificar'),
                    align: 'center',
                    sortable: false,
                    value: 'update'
                },
                {
                    text: this.$t('add_equipo_seguridad'),
                    align: 'center',
                    sortable: false,
                    value: 'add'
                },
                {
                    text: this.$t('add_attachment'),
                    align: 'center',
                    sortable: true,
                    value: 'doc'
                },
                {
                    text: this.$t('nombre'),
                    align: 'left',
                    sortable: true,
                    value: 'nombre'
                },
                {
                    text: 'Color',
                    align: 'left',
                    sortable: true,
                    value: 'color'
                }
            ],
            this.headers3 = [
                {
                    text: this.$t('modificar'),
                    align: 'center',
                    sortable: false,
                    value: 'update'
                },
                // {
                //     text: this.$t('add_equipo_seguridad'),
                //     align: 'center',
                //     sortable: false,
                //     value: 'add'
                // },
                // {
                //     text: 'ID',
                //     align: 'left',
                //     sortable: true,
                //     value: 'id'
                // },
                {
                    text: this.$t('nombre'),
                    align: 'left',
                    sortable: true,
                    value: 'nombre'
                },
                {
                    text: 'Color',
                    align: 'left',
                    sortable: true,
                    value: 'color'
                }
            ],
            this.headers2 = [
                {
                    text: this.$t('modificar'),
                    align: 'center',
                    sortable: false,
                    value: 'update'
                },
                {
                    text: this.$t('eliminar'),
                    align: 'center',
                    sortable: false,
                    value: 'eliminar'
                },
                {
                    text: this.$t('equipo_seguridad'),
                    align: 'left',
                    sortable: true,
                    value: 'nombre'
                },
            ],
            this.headersDoc = [
                {
                    text: this.$t('eliminar'),
                    align: 'center',
                    sortable: false,
                    value: 'eliminar'
                },
                {
                    text: 'Documentación',
                    align: 'left',
                    sortable: true,
                    value: 'name'
                },
            ]
        },
        computed: {
            ...mapGetters(['getProfile']),
            ...mapState(['language'])
        },
        mounted() {
            this.get_areas()
            this.fetchDocumentations()
        },
        methods: {
            async fetchDocumentations() {
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/documentation/ListCreate/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.documentations = response.data
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            onChange (val) {
                this.color = val
            },
            get_areas: function(){
                this.loading_data_areas = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/empresas/areas/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.areas = response.data
                        this.get_extra_data()
                        this.loading_data_areas = false
                    })
                    .catch(error => {
                        this.loading_data_areas = false
                        console.log(error)
                    })

            },
            get_equipo_area: function(){
                this.loading_data_equipo_area = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/get_SecurityEquipment/ByArea/' + this.id_area + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.equipos_area = response.data
                        this.loading_data_equipo_area = false
                    })
                    .catch(error => {
                        this.loading_data_equipo_area = false
                        console.log(error)
                    })

            },
            get_documentacion_area: function(){
                this.idDocumentation = '', this.documentacion_area = []
                this.loading_data_documentacion_area = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/getDocumentationByArea/' + this.id_area + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.documentacion_area = response.data
                        this.loading_data_documentacion_area = false
                    })
                    .catch(error => {
                        this.loading_data_documentacion_area = false
                        console.log(error)
                    })

            },
            get_extra_data: function(){
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/empresas/administradores/user/' + this.getProfile.id + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.id_empresa = response.data[0].id_empresa
                    })
                    .catch(error => {
                        console.log(error)
                    })

            },
            altaArea: function () {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.loading = true
                        this.errores = []
                        const config = {
                            method: 'post',
                            url: 'https://empresa-service.intrare.app/empresas/areas/',
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept-Language': this.language ,
                                'authorization': 'Token ' + store.getters.getToken
                            },
                            data: {
                                nombre: this.nombre,
                                color: this.color.hex,
                                id_empresa: this.id_empresa
                            }
                        };
                        axios(config)
                            .then(ok => {
                                this.loading = false
                                this.$store.commit('snackbar_activate_true')
                                this.$store.commit('snackbar_change_message', this.$t('mensaje_areas_alta'))
                                this.get_areas()
                                this.dialog = false
                                setTimeout(this.clear, 3000);
                            })
                            .catch(error => {
                                this.loading = false
                                if(error.response.status == 400
                                    && typeof error.response.data == "object"
                                    && error.response.data)
                                    this.errores = error.response.data
                            })
                    }
                }).catch((e) => {
                    console.log(e);// Failed
                });

            },
            updateArea: function (id) {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.loading = true
                        this.errores = []
                        const config = {
                            method: 'put',
                            url: 'https://empresa-service.intrare.app/empresas/areas/' + id +'/update/',
                            headers: {
                                'Content-Type': 'application/json',
                                'authorization': 'Token ' + store.getters.getToken
                            },
                            data: {
                                nombre: this.nombre,
                                color: this.color.hex,
                                id_empresa: this.id_empresa
                            }
                        };
                        axios(config)
                            .then(ok => {
                                this.loading = false
                                this.get_areas()
                                this.$store.commit('snackbar_activate_true')
                                this.$store.commit('snackbar_change_message', this.$t('mensaje_areas_modificado'))
                                this.dialog = false
                                setTimeout(this.clear, 3000);
                            })
                            .catch(error => {
                                this.loading = false
                                if(error.response.status == 400
                                    && typeof error.response.data == "object"
                                    && error.response.data)
                                    this.errores = error.response.data
                            })
                    }
                }).catch((e) => {
                    console.log(e);// Failed
                });
            },
            alta_equipo_area(){
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.errores = []
                        const config = {
                            method: 'post',
                            url: 'https://empresa-service.intrare.app/addSecurityEquipment',
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept-Language': this.language ,
                                'authorization': 'Token ' + store.getters.getToken
                            },
                            data: {
                                nameEquipment: this.nameEquipment,
                                idArea: this.id_area
                            }
                        };
                        axios(config)
                            .then(ok => {
                                this.$store.commit('snackbar_activate_true')
                                this.$store.commit('snackbar_change_message', this.$t('mensaje_areas_equipo_alta'))
                                this.get_equipo_area()
                                this.nameEquipment = ''
                                setTimeout(this.clear, 3000);
                            })
                            .catch(error => {
                                if(error.response.status == 400
                                    && typeof error.response.data == "object"
                                    && error.response.data)
                                    this.errores = error.response.data
                            })
                    }
                }).catch((e) => {
                    console.log(e);// Failed
                });
            },
            alta_documentacion_area (){
                this.loadingAddDocumentation = true
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.errores = []
                        const config = {
                            method: 'post',
                            url: 'https://empresa-service.intrare.app/addDocumentationByArea',
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept-Language': this.language ,
                                'authorization': 'Token ' + store.getters.getToken
                            },
                            data: {
                                idDocumentation: this.idDocumentation,
                                idArea: this.id_area
                            }
                        };
                        axios(config)
                            .then(ok => {
                                this.loadingAddDocumentation = false
                                this.$store.commit('snackbar_activate_true')
                                this.$store.commit('snackbar_change_message', this.$t('msg_attachment_added'))
                                this.get_documentacion_area()
                                this.idDocumentation  = ''
                                setTimeout(this.clear, 3000);
                            })
                            .catch(error => {
                                this.loadingAddDocumentation = false
                                if(error.response.status == 400
                                    && typeof error.response.data == "object"
                                    && error.response.data) {
                                    this.errores = error.response.data
                                    if (error.response.data.non_field_errors)
                                        this.errores.idDocumentation = error.response.data.non_field_errors
                                    }
                            })
                    }
                }).catch((e) => {
                    this.loadingAddDocumentation = false
                    console.log(e);// Failed
                });
            },
            modificar_equipo_area() {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        const config = {
                            method: 'patch',
                            url: 'https://empresa-service.intrare.app/updateSecurityEquipment/' + this.id_equipament + '/',
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept-Language': this.language ,
                                'authorization': 'Token ' + store.getters.getToken
                            },
                            data: {
                                nameEquipment: this.nameEquipment_update
                            }
                        };
                        axios(config)
                            .then(ok => {
                                this.$store.commit('snackbar_activate_true')
                                this.$store.commit('snackbar_change_message', this.$t('mensaje_areas_equipo_update'))
                                this.get_equipo_area()
                                this.dialog_update_equipament = false
                                this.nameEquipment_update = ''
                                setTimeout(this.clear, 3000);
                            })
                            .catch(error => {
                                if(error.response.status == 400
                                    && typeof error.response.data == "object"
                                    && error.response.data)
                                    this.errores = error.response.data
                            })
                    }
                }).catch((e) => {
                    console.log(e);// Failed
                });
            },
            eliminar_equipo_area(id_equipo) {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        const config = {
                            method: 'delete',
                            url: 'https://empresa-service.intrare.app/deleteSecurityEquipment/' + id_equipo + '/',
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept-Language': this.language ,
                                'authorization': 'Token ' + store.getters.getToken
                            },
                        };
                        axios(config)
                            .then(ok => {
                                this.$store.commit('snackbar_activate_true')
                                this.$store.commit('snackbar_change_color', 'warning')
                                this.$store.commit('snackbar_change_message', this.$t('mensaje_areas_equipo_delete'))
                                this.get_equipo_area()
                                setTimeout(this.clear, 3000);
                            })
                            .catch(error => {
                                if(error.response.status == 400
                                    && typeof error.response.data == "object"
                                    && error.response.data)
                                    this.errores = error.response.data
                            })
                    }
                }).catch((e) => {
                    console.log(e);// Failed
                });
            },
            eliminar_documentacion_area(idDocumentacionByArea) {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        const config = {
                            method: 'delete',
                            url: 'https://empresa-service.intrare.app/deleteDocumentationByArea/' + idDocumentacionByArea + '/',
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept-Language': this.language ,
                                'authorization': 'Token ' + store.getters.getToken
                            },
                        };
                        axios(config)
                            .then(ok => {
                                this.$store.commit('snackbar_activate_true')
                                this.$store.commit('snackbar_change_color', 'warning')
                                this.$store.commit('snackbar_change_message', this.$t('msg_attachment_deleted'))
                                this.get_documentacion_area()
                                setTimeout(this.clear, 3000);
                            })
                            .catch(error => {
                                if(error.response.status == 400
                                    && typeof error.response.data == "object"
                                    && error.response.data)
                                    this.errores = error.response.data
                            })
                    }
                }).catch((e) => {
                    console.log(e);// Failed
                });
            },
            clear: function () {
                this.alerta = false
                this.errores = []
                this.$validator.reset()
                this.$store.commit('snackbar_change_color', 'success')
                this.$store.commit('snackbar_activate_false')
            },
            fill_fields(item){
                this.errores = []
                this.nombre = item.nombre
                this.color = {
                    hex: item.color
                }
            },
            clean_fields(){
                this.errores = []
                this.nameEquipment = ''
                this.nombre = ''
                this.color = {
                    hex: '#E6B3B3'
                }
            }
        }
    }
</script>


<style scoped>
    table{
        background-color: white;
        text-align: left;
        border-collapse: collapse;
        width: 100%;
    }

    th, td{
        padding: 20px;
    }

    thead{
        background-color: #002b48;
        color: white;

    }

    tr:nth-child(even){
        background-color: #ddd;
    }

    tr:hover td{
        background-color: rgba(25,118,210, 0.8);
        color: white;
    }

</style>
